import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../Core/store';
//import { Credentials } from '../Models/Requests/Credentials';
import { axiosPrivate } from '../Core/axios';
//import { Project } from '../Models/Project';
//import { List } from '../Models/List';
import { settingsStatus } from '../Helpers/types';
//import { decodeToken } from '../Helpers/DecodeToken';
//import { NewListParams } from '../Models/Requests/NewListParams';
//import { Settings } from 'http2';
import { Settings } from '../Models/Settings';
import { loadedComponentType, loadedSubComponentType } from '../Helpers/types';
import { loadedComponentRequest } from '../Models/Requests/LoadComponentRequest';
import { SavePreviousComponentParams } from '../Models/Requests/SavePreviousComponentParams';
//import { userSliceStatus } from '../Helpers/types';
//import { PasswordReset } from '../Models/Requests/PasswordReset';
import { Socket, Manager } from 'socket.io-client';
import { Member } from '../Models/Requests/Member';

/*
interface UserInComment {
  user: Member;
  inserted: boolean;
}
*/
export interface SettingsState {
  //showProjects: boolean;
  status: settingsStatus;
  errorMessage: string;
  socket: any;
  version: string;
  settings: Settings;
  userInComment: Member | undefined;
  //avatar: string;
  //showingHelp: boolean;
  //defaultAvatarColor: string;
  //defaultAvatarFontColor: string;
  //userId: number;
  //timeZone: string;
  //herdrExpanded: boolean;
  //roadmapsExpanded: boolean;
  //workExpanded: boolean;
  //actionExpanded: boolean;
  //chatExpanded: boolean;
}

const initialState: SettingsState = {
  //showProjects: false,
  status: "unset",
  errorMessage: "",
  socket: null,
  version: "",
  settings: {
    _id: "",
    userId: "",
    herdrExpanded: false,
    roadmapsExpanded: false,
    workExpanded: false,
    actionExpanded: false,
    chatExpanded: false,
    created: "",
    modified: "",
    lastComponentTypeSwitch: "",
    loadedComponentType: "",
    //loadedComponentSubtype: "",
    previousComponentType: "",
    //previousComponentSubtype: "",
    projectCreation: "roadmap_item",
    sidebarExpanded: true,
    searchText: "",
    chatChannelsExpanded: false,
    chatMessagesExpanded: false,
  },
  userInComment: undefined,
};

export const loadComponent = createAsyncThunk(
  'api/settings/component',
  async (component: loadedComponentRequest) => {    
    return await axiosPrivate.put('api/settings/component',
      JSON.stringify(component),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    ).then(
      (res) => {
        return res.data;
      }
    );
});
export const toggleHerdr = createAsyncThunk(
  'api/settings/toggle/herdr',
  async (show: boolean) => {    
    return await axiosPrivate.put('api/settings/toggle/herdr',
      JSON.stringify({
        show: show,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    ).then(
      (res) => {
        return res.data;
      }
    );
});
export const toggleRoadmaps = createAsyncThunk(
  'api/settings/toggle/roadmaps',
  async (show: boolean) => {    
    return await axiosPrivate.put('api/settings/toggle/roadmaps',
      JSON.stringify({
        show: show,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    ).then(
      (res) => {
        return res.data;
      }
    );
});
export const toggleWork = createAsyncThunk(
  'api/settings/toggle/work',
  async (show: boolean) => {    
    return await axiosPrivate.put('api/settings/toggle/work',
      JSON.stringify({
        show: show,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    ).then(
      (res) => {
        return res.data;
      }
    );
});
export const toggleAction = createAsyncThunk(
  'api/settings/toggle/action',
  async (show: boolean) => {    
    return await axiosPrivate.put('api/settings/toggle/action',
      JSON.stringify({
        show: show,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    ).then(
      (res) => {
        return res.data;
      }
    );
});
export const toggleChat = createAsyncThunk(
  'api/settings/toggle/chat',
  async (show: boolean) => {    
    return await axiosPrivate.put('api/settings/toggle/chat',
      JSON.stringify({
        show: show,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    ).then(
      (res) => {
        return res.data;
      }
    );
});
export const toggleChatChannels = createAsyncThunk(
  'toggle-chat-channels',
  async (show: boolean) => {    
    return await axiosPrivate.put('api/settings/toggle/chat/channels',
      JSON.stringify({
        show: show,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    ).then(
      (res) => {
        return res.data;
      }
    );
});
export const toggleChatMessages = createAsyncThunk(
  'toggle-chat-messages',
  async (show: boolean) => {    
    return await axiosPrivate.put('api/settings/toggle/chat/messages',
      JSON.stringify({
        show: show,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    ).then(
      (res) => {
        return res.data;
      }
    );
});
export const saveProjectCreation = createAsyncThunk(
  'api/settings/project/creation',
  async (projectCreation: string) => {    
    return await axiosPrivate.put('api/settings/project/creation',
      JSON.stringify({
        projectCreation: projectCreation,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    ).then(
      (res) => {
        return res.data;
      }
    );
});
/*
export const saveSidebarSetting = createAsyncThunk(
  'api/settings/save/sidebar',
  async (show: boolean) => {    
    return await axiosPrivate.put('api/settings',
      JSON.stringify({
        show: show,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    ).then(
      (res) => {
        //setShowSidebar(res.data.data);
        return res.data.showProjects;
      }
    );
});
*/
export const getUserSettings = createAsyncThunk(
  'api/settings/get/user/settings',
  async () => {    
    return await axiosPrivate.get('api/settings',
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    ).then(
      (res) => {
        return res.data;
      }
    );
});

export const heartBeat = createAsyncThunk(
  'api/settings/heartbeat',
  async () => {    
    return await axiosPrivate.get('api/settings/heartbeat',
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    ).then(
      (res) => {
        return res.data;
      }
    );
});
/*
export const getVersion = createAsyncThunk(
  'api/settings/version',
  async () => {    
    return await axiosPrivate.get('api/settings/version',
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    ).then(
      (res) => {
        return res.data;
      }
    );
});
*/
export const savePreviousComponent = createAsyncThunk(
  'api/settings/previous/component',
  async (previousComponent: SavePreviousComponentParams) => {    
    return await axiosPrivate.put('api/settings/previous/component',
      JSON.stringify(previousComponent),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    ).then(
      (res) => {
        return res.data;
      }
    );
});

export const toggleSidebar = createAsyncThunk(
  'toggle-sidebar',
  async (value: boolean) => {    
    return await axiosPrivate.put('api/settings/sidebar',
      JSON.stringify({
        value: value
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    ).then(
      (res) => {
        return res.data;
      }
    );
});

export const setSearchText = createAsyncThunk(
  'save-search',
  async (text: string) => {    
      return text;
});

export const setSocket = createAsyncThunk(
  'set-socket',
  async (socket: Socket | null) => {    
      return socket;
});

export const setSettingsStatus = createAsyncThunk(
  'set-settings-status',
  async (status: settingsStatus) => {    
      return status;
});

export const setInsertUserInComment = createAsyncThunk(
  'set-insert-user-in-comment',
  async (userInComment: Member | undefined) => {    
      return userInComment;
});

/*
export const setShowHelp = createAsyncThunk(
'setShowHelp',
  async (show: boolean) => {    
      return show;
});
*/
export const SettingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(heartBeat.fulfilled, (state, action) => {
        state.status = 'heartbeat';
        state.version = action.payload.version;
      })
      /*
      .addCase(getVersion.fulfilled, (state, action) => {
        state.version = action.payload.version;
      })
      */
      .addCase(setSettingsStatus.fulfilled, (state, action) => {
        state.status = action.payload;
      })
      .addCase(setSocket.fulfilled, (state, action) => {
        state.status = 'idle';
        //let settings = {...state};
        //settings.socket = action.payload;
        //let socket: Socket = {...action.payload as unknown as Socket};
        state.socket = action.payload;
      })
      .addCase(setSearchText.fulfilled, (state, action) => {
        state.status = 'idle';
        let settings: Settings = {...state.settings};
        settings.searchText = action.payload;
        state.settings = settings;
      })
      .addCase(setInsertUserInComment.fulfilled, (state, action) => {
        state.status = 'idle';
        state.userInComment = action.payload;
      })
      .addCase(toggleSidebar.fulfilled, (state, action) => {
        state.status = 'idle';
        let settings: Settings = {...state.settings};
        settings.sidebarExpanded = action.payload;
        state.settings = settings;
      })
      .addCase(toggleChatChannels.fulfilled, (state, action) => {
        state.status = 'idle';
        let settings: Settings = {...state.settings};
        settings.chatChannelsExpanded = action.payload;
        state.settings = settings;
      })
      .addCase(toggleChatMessages.fulfilled, (state, action) => {
        state.status = 'idle';
        let settings: Settings = {...state.settings};
        settings.chatMessagesExpanded = action.payload;
        state.settings = settings;
      })
      .addCase(saveProjectCreation.fulfilled, (state, action) => {
        state.status = 'idle';
        let settings: Settings = {...state.settings};
        settings.projectCreation = action.payload;
        state.settings = settings;
      })
      .addCase(loadComponent.pending, (state) => {
        state.status = 'loadingComponent';
      })
      .addCase(loadComponent.fulfilled, (state, action) => {
        state.status = 'idle';
        let settings: Settings = {...state.settings};
        //console.log(settings.loadedComponentType);
        if (settings.loadedComponentType === "chat") {
          /* When switching off the chat tab, log it for new message notifcation tracking */
          //console.log(action.payload.lastComponentTypeSwitch);
          settings.lastComponentTypeSwitch = action.payload.lastComponentTypeSwitch;
        }
        settings.loadedComponentType = action.payload.loadedComponentType;
        //console.log(settings.loadedComponentType);
        
        //settings.loadedComponentSubtype = action.payload.loadedComponentSubtype;
        state.settings = settings;
      })
      .addCase(savePreviousComponent.fulfilled, (state, action) => {
        state.status = 'idle';
        let settings: Settings = {...state.settings};
        settings.previousComponentType = action.payload.previousComponentType;
        state.settings = settings;
      })
      .addCase(toggleHerdr.fulfilled, (state, action) => {
        state.status = 'idle';
        let settings: Settings = {...state.settings};
        settings.herdrExpanded = action.payload;;
        state.settings = settings;
      })
      .addCase(toggleRoadmaps.fulfilled, (state, action) => {
        state.status = 'idle';
        let settings: Settings = {...state.settings};
        settings.roadmapsExpanded = action.payload;;
        state.settings = settings;
      })
      .addCase(toggleWork.fulfilled, (state, action) => {
        state.status = 'idle';
        let settings: Settings = {...state.settings};
        settings.workExpanded = action.payload;;
        state.settings = settings;
      })
      .addCase(toggleAction.fulfilled, (state, action) => {
        state.status = 'idle';
        let settings: Settings = {...state.settings};
        settings.actionExpanded = action.payload;;
        state.settings = settings;
      })
      .addCase(toggleChat.fulfilled, (state, action) => {
        state.status = 'idle';
        let settings: Settings = {...state.settings};
        settings.chatExpanded = action.payload;;
        state.settings = settings;
      })
      /*
      .addCase(saveSidebarSetting.fulfilled, (state, action) => {
        state.status = 'idle';
        state.showProjects = action.payload;
      })
      .addCase(saveSidebarSetting.rejected, (state, action) => {
        state.status = 'failed';
        state.errorMessage = action.error.message as string;
      })
        */
      .addCase(getUserSettings.fulfilled, (state, action) => {
        state.status = 'idle';
        //let settings: SettingsState = action.payload;
        state.settings = action.payload;
      })
      .addCase(getUserSettings.rejected, (state, action) => {
        state.status = 'failed';
        state.errorMessage = action.error.message as string;
      })
      /*
      .addCase(setShowHelp.fulfilled, (state, action) => {
        state.status = 'idle';
        state.showingHelp = action.payload;
      })
        */
  },
});

export const getSettings = (state: RootState) => state.settings;
export default SettingsSlice.reducer;
